// extracted by mini-css-extract-plugin
module.exports = {"profileContainer":"UserEmailVerification_profileContainer__1M3At","profile":"UserEmailVerification_profile__2QxZ7","tokens":"UserEmailVerification_tokens__3a9bd"};